module.exports = __webpack_public_path__ + "img/sld_ch_12_t1_green.83223d90.svg";